//import Dummy_Sec from "../collection_landing_page/sections/dummy_sec";
//import FAQ from "../collection_landing_page/sections/faq";
//import BreadCrumb from "../ui/breadcrumb/breadcrumb";
//import CtaBtn from "../ui/cta-btn";
//import Application from "./sections/application";
//import Category from "./sections/category";
import { formatTitle, generateBreadcrumbSchema } from "@/utils/constants";
import Faces from "./sections/faces";
//import Link_Button_Sec from "./sections/linkButtonSec";
//import Packing_Details from "./sections/packing_details";
//import Product_Slider from "./sections/product_slider";
//import Product_Slider_Details from "./sections/product_slider_details";
// import Related_Collections from "./sections/related_collections";
// import Related_Products from "./sections/related_products";

import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import Head from "next/head";

const Dummy_Sec = dynamic(
  import("../collection_landing_page/sections/dummy_sec"),
  { ssr: true }
);
const FAQ = dynamic(import("../collection_landing_page/sections/faq"), {
  ssr: true,
});
const BreadCrumb = dynamic(import("../ui/breadcrumb/breadcrumb"), {
  ssr: true,
});

const CtaBtn = dynamic(import("../ui/cta-btn"), { ssr: true });
const Application = dynamic(import("./sections/application"), { ssr: true });
const Category = dynamic(import("./sections/category"), { ssr: true });
const Link_Button_Sec = dynamic(import("./sections/linkButtonSec"), {
  ssr: true,
});
const Packing_Details = dynamic(import("./sections/packing_details"), {
  ssr: true,
});
const Product_Slider = dynamic(import("./sections/product_slider"), {
  ssr: true,
});
const Product_Slider_Details = dynamic(
  import("./sections/product_slider_details"),
  { ssr: true }
);
const Related_Collections = dynamic(import("./sections/related_collections"), {
  ssr: true,
});
const Related_Products = dynamic(import("./sections/related_products"), {
  ssr: true,
});

const Product_Detail_Page = ({ productDetailsUrl, productData, currentUrl }) => {
  const productDetailsApiData = useSelector(
    (state) => state.productDetailsData
  );

  const productSliderImage = productData?.gallery || [];
  const facesData = productData?.faces
    ? Object.values(productData?.faces)
    : [];
  const categoryData = productData?.categories || [];
  const applicationData = productData?.features || [];
  const packingDetails = productData?.packagings || [];
  const relatedProducts = productData?.related_products || [];
  const relatedCollections = productData?.related_collections || [];
  const FAQ_Data = productData?.faqs || [];
  const beforeFooterSection = productData?.before_footer || {};
  const product_name = productData?.product_name || {};

  const breadcrumbData = [
    {
      title: "Tiles",
      link: "/tiles/products",
    },

    {
      title: formatTitle(productData?.product_name),
    },
  ];
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateBreadcrumbSchema(breadcrumbData, currentUrl)
            ),
          }}
        />
      </Head>
      <section>
        <div className="py-5 lg:py-[2vw]">
          <BreadCrumb
            breadcrumbData={breadcrumbData}
            customClass={"sm:!relative sm:!bottom-0"}
          />
        </div>

        <div className="lg:flex lg:flex-wrap container justify-between">
          <div className="lg:w-[55%] mb-5 lg:mb-0">
            <Product_Slider productSliderImage={productSliderImage} productDetails={productData} />
          </div>

          <div className="lg:w-[42%]">
            <Product_Slider_Details
              productDetailsUrl={productDetailsUrl}
              productDetails={productData}
            />
          </div>
        </div>
      </section>

      {/* <Faces facesData={facesData} /> */}
      <Category categoryData={categoryData} />
      <Application
        productDetails={productData}
        applicationData={applicationData}
      />
      <Link_Button_Sec productDetails={productData} />
      <Packing_Details packingDetails={packingDetails} />
      <Related_Products relatedProducts={relatedProducts} />
      {/* <Related_Collections relatedCollections={relatedCollections} /> */}
      {/* <FAQ FAQ_Data={FAQ_Data} />
      <Dummy_Sec beforeFooterSection={beforeFooterSection} /> */}
    </>
  );
};

export default Product_Detail_Page;
